import { styled, css } from '@mui/material/styles';
import { Box, Button as Btn, Typography } from '@mui/material';

export const Container = styled(Box)`
  /* max-height: calc(100vh - 60px); */
  width: 100%;
  padding: 42px 30px 42px 30px;
  overflow-y: overlay;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.grey[50]};
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #616161;
  white-space: nowrap;
  padding: 10px;
`;

export const Filters = styled(Box)`
  display: flex;
  flex-direction: row;

  .container-filters {
    display: flex;
    flex-direction: row;
    width: 100%;

    margin-right: 20px;
  }

  .date-filter {
    display: flex;
    justify-content: space-evenly;

    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    border-radius: 5px;
    width: 128px;
    height: 42px;
    margin: 20px 0px 20px 25px;
    color: ${({ theme }) => theme.palette.primary.main};
    //styleName: Button text / L;
    gap: 5px;
    font-size: 15px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-align: start;
    padding: 6px 22px;
  }

  .filter {
    display: flex;
    justify-content: space-evenly;

    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    border-radius: 5px;
    width: 158px;
    height: 42px;
    margin: 20px 0px 20px 25px;
    color: ${({ theme }) => theme.palette.primary.main};
    //styleName: Button text / L;
    gap: 5px;
    font-size: 15px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-align: start;
    padding: 6px 22px;
  }
`;

export const Div = styled(Box)`
  width: 300px;
  height: 300px;

  .list-meeting {
    width: 300px;
    height: 300px;
  }
`;

export const Page = styled(Box)`
  width: 100%;

  display: flex;
  flex-direction: column;
`;

interface ButtonProps {
  active: boolean;
}

export const PageMeetings = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
  .section-meetings {
    display: flex;
    flex-direction: row;
    background: #ffffff;
    border-radius: 4px;
    Button {
      width: 160px;
      height: 48px;
      padding: 17px 43px;
      border-radius: 0;
    }
  }

  .btn-meetings-futures {
    width: 160px;
    height: 42px;
    font-size: 13px;
    white-space: nowrap;
    border-radius: 0px;
  }

  .btn-meetings-previous {
    width: 160px;
    height: 42px;
    font-size: 13px;
    white-space: nowrap;
    border-radius: 0px;
  }

  .section-new-meeting {
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .btn-new-meeting {
    width: 160px;
    height: 42px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};
    font-size: 15px;
  }
`;

export const TabButton = styled(Btn)`
  color: rgba(0, 0, 0, 0.54);
  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
    `}
`;

export const Button = styled(Btn)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 22px;
  white-space: nowrap;
  width: 200px;
  height: 48px;
  background: #206da7;
  border-radius: 4px;
`;

export const HeaderCreate = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 10px 10px 10px;
  padding: 0px 0px 16px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 20px;
`;

export const TitleBox = styled(Box)`
  margin-left: 38%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;
